// import axios from 'axios';
// import { queryBot } from 'boot/axios';

export const UserStatus = {
    New: 0, // Новый - после добавления в базу если нет активного курса - статус "новый"
    Study: 1, // Обучение – прогресс активного курса обучаемого < 99%
    Refusal: 2, // Отказ – у обучаемого пустое поле “активный курс”
    Diploma: 3, // Диплом – прогресс активного курса обучаемого = 99%
    Success: 4, // Успех – прогресс активного курса обучаемого = 100% (за него внесена оплата)
};

export const PartnerLogCodes = {
    Authorized: 1,
    StartEntry: 2,
    FinishEntry: 3,
    AdmissionTrue: 4,
    AdmissionFalse: 5,
    TaskDone: 6,
    FinishModule: 7,
    EsseDone: 8,
    FinishCourse: 9,
    SkipTask: 10,
    Paid: 11,
};

const PartnerLog = [
    { code: PartnerLogCodes.Authorized, status: 'Первичная авторизация пройдена' },
    { code: PartnerLogCodes.StartEntry, status: 'Входная диагностика начата' },
    { code: PartnerLogCodes.FinishEntry, status: 'Входная диагностика завершена' },
    { code: PartnerLogCodes.AdmissionTrue, status: 'Допуск на курс получен' },
    { code: PartnerLogCodes.AdmissionFalse, status: 'В допуске на курс отказано' },
    { code: PartnerLogCodes.TaskDone, status: 'Пройдена тема %s' },
    { code: PartnerLogCodes.EsseDone, status: 'Рефлексия написана %s' },
    { code: PartnerLogCodes.FinishModule, status: 'Модуль завершен %s' },
    { code: PartnerLogCodes.FinishCourse, status: 'Курс завершен %s' },
    { code: PartnerLogCodes.SkipTask, status: 'Пропущена тема %s' },
    { code: PartnerLogCodes.Paid, status: 'Оплата произведена' },
];

export default PartnerLog;

/*
    1 - первичная авторизация пройдена
    2 - входная диагностика начата
    3 - входная диагностика завершена
    4 - допуск на курс (пока что всегда true)
    5 - прогресс обучения % (после выполнения темы)
    6 - модуль завершен, требуется эссе (супермодуль, отправка цс)
    7 - эссе написано
    8 - курс завершен
    9 - оплата произведена
*/

export function sendPartnerLog (email, courseId, code, extra, progress) {
    console.log(progress);
    /*
    const usePartner = sessionStorage.getItem('usePartner') === 'true';
    if (!usePartner) { return; }

    const url = 'https://partner.1t.ru/api/member_activity';
    const [p] = PartnerLog.filter((i) => i.code === code);
    let status = '';
    if (p) {
        status = p.status;
    }
    status = status.replace('%s', extra);

    const data = {
        email,
        course_id: courseId,
        code,
        status,
        progress,
    };
    axios.post(url, data).then(() => {
        // console.log(r);
    }).catch((e) => {
        console.log(e);
    });
   */
}

export function sendPartnerStatus (user, status, course) {
    console.log(course);
    /*
    const usePartner = sessionStorage.getItem('usePartner') === 'true';
    if (!usePartner) { return; }

    const url = 'https://partner.1t.ru/api/member_status';

    const c = course || null;
    const data = {
        email: user.email,
        public_service: user.has_gosuslugi,
        status: status.toString(),
        course: c,
    };
    axios.post(url, data).then((r) => {
        console.log(r);
    }).catch((e) => {
        console.log(e);
    });
     */
}

export function sendPartnerUpdateProfile (email, user) {
    console.log(user?.test);
    /*
    const usePartner = sessionStorage.getItem('usePartner') === 'true';
    if (!usePartner) { return undefined; }

    const url = 'https://partner.1t.ru/api/member_info_change';
    const data = {
        email,
        public_service: user.has_gosuslugi,
        shownname: user.shownname,
        phone: user.tel,
        region_id: user.region_number,
    };
    console.log('data:', data);
    return axios.post(url, data).then(() => {
        // console.log(r);
    }).catch((e) => {
        console.log(e);
    });
     */
}

export async function sendPartnerConnect (context, u, partnerGuid) {
    console.log(partnerGuid);
    /*
    const usePartner = sessionStorage.getItem('usePartner') === 'true';
    if (!usePartner) { return; }

    const url = 'https://partner.1t.ru/api/connect';

    let originalCourse;
    const name = `${u.firstname} ${u.secondname} ${u.lastname}`.trim().replace('  ', ' ');
    const data = new FormData();
    const alias = localStorage.getItem('auto-entry');

    if (!alias) {
        await queryBot(`select last_course_id from users where email = '${u.email}'`).then(async (r) => {
            const [row] = r.data;
            if (row) {
                const i = row.last_course_id;
                [originalCourse] = await context.$db.tasks.getCourses(`id = '${i}'`);
            }
        });
    } else {
        [originalCourse] = await context.$db.tasks.getCourses(`alias = '${alias}'`);
    }
    let course;
    if (originalCourse) {
        let price = 0;
        await queryBot(`select price from courses_price where course_id = '${originalCourse.id}' limit 1`).then((r) => {
            const [row] = r.data;
            if (row) {
                price = row.price;
            }
        });
        course = {
            alias: originalCourse.alias,
            name: originalCourse.title,
            cost: price,
        };
    }

    data.append('email', u.email);
    data.append('shownname', name);
    data.append('has_gosuslugi', 0);
    data.append('course', JSON.stringify(course));
    data.append('current_status', '1');
    // data.append('region_id', '');
    data.append('progress', '0');
    data.append('partner_guid', partnerGuid);

    await axios.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }).then((r) => {
        console.log(r);
    })
        .catch((e) => {
            console.log(e);
        });
  */
}
